const actions = [
  {
    id: 'facebook',
    icon: 'ri-facebook-circle-fill',
    title: 'Join Facebook Group',
    description:
      'Connect with other CSCF families in our private Facebook group. Share updates, ask questions, and find people who truly understand.',
    buttonLabel: 'Join the Group',
    buttonHref: 'https://www.facebook.com/groups/',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-500',
    border: 'border-blue-100',
    buttonBg: 'bg-blue-500 hover:bg-blue-600',
    tag: 'Social',
    tagColor: 'text-blue-400',
  },
  {
    id: 'updates',
    icon: 'ri-mail-send-line',
    title: 'Sign Up for Updates',
    description:
      'Stay informed about new research, community events, and resources. We send occasional, meaningful updates — never spam.',
    buttonLabel: 'Subscribe',
    buttonHref: '#updates-form',
    iconBg: 'bg-brand-50',
    iconColor: 'text-brand-500',
    border: 'border-brand-100',
    buttonBg: 'bg-brand-500 hover:bg-brand-600',
    tag: 'Newsletter',
    tagColor: 'text-brand-400',
  },
  {
    id: 'story',
    icon: 'ri-quill-pen-line',
    title: 'Share Your Story',
    description:
      'Your experience matters. Sharing your journey helps other families feel less alone and contributes to the collective knowledge about CSCF.',
    buttonLabel: 'Share Your Story',
    buttonHref: '#story-form',
    iconBg: 'bg-accent-50',
    iconColor: 'text-accent-500',
    border: 'border-accent-100',
    buttonBg: 'bg-accent-500 hover:bg-accent-600',
    tag: 'Stories',
    tagColor: 'text-accent-400',
  },
  {
    id: 'resource',
    icon: 'ri-share-line',
    title: 'Share a Resource',
    description:
      'Know a helpful article, tool, or organization? Share it with the community so others can benefit from what you\'ve found useful.',
    buttonLabel: 'Share a Resource',
    buttonHref: '#resource-form',
    iconBg: 'bg-green-50',
    iconColor: 'text-green-600',
    border: 'border-green-100',
    buttonBg: 'bg-green-600 hover:bg-green-700',
    tag: 'Resources',
    tagColor: 'text-green-500',
  },
];

export default function ConnectButtons() {
  return (
    <section id="connect" className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-block px-4 py-1.5 bg-brand-50 border border-brand-100 rounded-full mb-4">
            <span className="text-xs font-semibold text-brand-600 tracking-widest font-heading">GET INVOLVED</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-heading">
            Ways to Connect
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto font-body leading-relaxed">
            Whether you want to talk to other families, stay informed, or share your experience — there is a way for you to be part of this community.
          </p>
        </div>

        {/* 4-column action cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {actions.map((action) => (
            <div
              key={action.id}
              className={`bg-white border ${action.border} rounded-2xl p-8 flex flex-col items-start`}
            >
              {/* Tag */}
              <span className={`text-xs font-semibold uppercase tracking-widest font-heading mb-4 ${action.tagColor}`}>
                {action.tag}
              </span>

              {/* Icon */}
              <div className={`w-14 h-14 flex items-center justify-center ${action.iconBg} rounded-2xl mb-5`}>
                <i className={`${action.icon} text-3xl ${action.iconColor}`}></i>
              </div>

              {/* Text */}
              <h3 className="text-xl font-bold text-gray-900 font-heading mb-3">{action.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed font-body flex-grow mb-7">
                {action.description}
              </p>

              {/* Button */}
              <a
                href={action.buttonHref}
                className={`inline-flex items-center gap-2 px-6 py-3 ${action.buttonBg} text-white font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer font-body text-sm w-full justify-center`}
              >
                <i className={action.icon}></i>
                {action.buttonLabel}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
